import { EMP_LIST, BULK_APPROVE_TASK, EMP_LIST_BYPROJECTID,SUP_LIST } from "./ActionType";

const initialValue = {
    emplists: [],
    supportlists: [],
    empListByProjectId: [],
    bulkapprove: [],
}

export const dailyUpdateApprovalReducer = (store = initialValue, { type, payload }) => {

    if (type === EMP_LIST) {
        return {
            ...store, emplists: payload.userList || [],
        };
    } else if (type === BULK_APPROVE_TASK) {
        return {
            ...store, bulkapprove: payload.userList || [],
        };
    } else if (type === EMP_LIST_BYPROJECTID) {
        return {
            ...store, empListByProjectId: payload.userList || [],
        };
    } else if (type === SUP_LIST) {
        return {
            ...store, supportlists: payload.userList || [],
        };
    }

    return store
}